import React from 'react'
import { Order } from '@/types/order'
import { OrderDetailsCard } from './OrderDetailsCard'
import { TableCard } from '../../../components/shared/table-card'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { CartItemsTable } from './CartItemsTable'
import { useQuery } from '@apollo/client'
import { GET_USER } from '../../Organisation/membersQueries'
import { useDemoMode } from '@/context/DemoModeContext'
import useOpenDrawer from '@/hooks/useOpenDrawer'
import B2BCustomerForm from '@/containers/B2BCustomers/B2BCustomerForm'
import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface OrderSummarySectionProps {
  order: Order
  className?: string
}

export const OrderSummarySection: React.FC<OrderSummarySectionProps> = ({
  order,
  className,
}) => {
  const { isDemoMode } = useDemoMode()
  const openB2BCustomerForm = useOpenDrawer(B2BCustomerForm)
  const { data: managerData, loading: managerLoading } = useQuery(GET_USER, {
    variables: { id: order.metadata?.managerId },
    skip: !order.metadata?.managerId,
  })

  const managerUser = managerData?.findUniqueUser

  return (
    <div className={`space-y-8 ${className}`}>
      <OrderDetailsCard order={order} />

      <TableCard
        title="Customer"
        titleAction={
          order.purchased_by ? (
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6"
              onClick={() => openB2BCustomerForm({ id: Number(order.purchased_by!.id) })}
            >
              <ExternalLink className="h-4 w-4" />
            </Button>
          ) : undefined
        }
        data={
          order.purchased_by
            ? [
                {
                  label: 'Account Code',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_by.account_code || 'N/A'}
                    </span>
                  ),
                },
                {
                  label: 'Name',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_by.b2b_company_name ||
                        (order.purchased_by.name && order.purchased_by.surname
                          ? `${order.purchased_by.name} ${order.purchased_by.surname}`
                          : order.purchased_by.name ||
                            order.purchased_by.surname ||
                            'N/A')}
                    </span>
                  ),
                },
                {
                  label: 'Email',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_by.email || 'N/A'}
                    </span>
                  ),
                },
              ]
            : []
        }
      />
      <TableCard
        title="Order Placed By"
        data={
          order.purchased_by
            ? [
                ...(order.metadata?.managerId
                  ? [
                      {
                        label: 'Sales Manager',
                        value: (
                          <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                            {managerLoading
                              ? 'Loading...'
                              : managerUser
                              ? `${managerUser.profile?.name || ''} ${
                                  managerUser.profile?.surname || ''
                                } (${managerUser.email})`.trim()
                              : "Manager doesn't exist"}
                          </span>
                        ),
                      },
                    ]
                  : []),
                {
                  label: 'User',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_customerAccount?.name
                        ? order.purchased_customerAccount?.name +
                          ' (' +
                          order.purchased_customerAccount?.email +
                          ')'
                        : 'N/A'}
                    </span>
                  ),
                },
                {
                  label: 'Account',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_by?.b2b_company_name ||
                        order.purchased_by?.name ||
                        'N/A'}
                    </span>
                  ),
                },
                {
                  label: 'Role',
                  value: 'N/A',
                },
                {
                  label: 'Location',
                  value: (
                    <span className={isDemoMode ? 'blur-sm select-none' : ''}>
                      {order.purchased_subAccount?.name || 'N/A'}
                    </span>
                  ),
                },
              ]
            : []
        }
      />
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          Notes
        </CardHeader>
        <CardContent className={`text-xs ${isDemoMode ? 'blur-sm select-none' : ''}`}>
          {order.order_notes}
        </CardContent>
      </Card>
      {/* <TableCard title="Payment" data={[]} />

      <TableCard title="Shipping Address" data={[]} /> */}
    </div>
  )
}
